import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../hooks/GlobalProvider"; // Correct path
import LogoLoader from "../components/LogoLoader/LogoLoader"; // Import loader

// Protected route for regular users
const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return <LogoLoader />;
  }
  
  return user ? children : <Navigate to="/signin" />;
};

// Admin only route - requires user to be logged in AND not have customer role
const AdminRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  // Show loader while checking authentication
  if (loading) {
    return <LogoLoader />;
  }
  
  // Check if user exists and is NOT a customer
  // Allow all roles except "customer"
  const isAllowed = user && user.role !== "customer";
  
  return isAllowed ? children : <Navigate to="/signin" />;
};

export { ProtectedRoute, AdminRoute };